export default __webpack_public_path__ + "static/md-a60006c4a2acfc0b3e43efba45ee9b50.svg";